import { useRecoilState } from 'recoil';

import {
  vehiclesInitialState,
  vehiclesMetaState,
  vehiclesState,
  vehiclesViewState,
} from '@/states/used-cars/vehicles.state';
import { Vehicle } from '@/types/used-cars/used-cars.types';

export function useVehicles() {
  const [vehicles, setVehicles] = useRecoilState(vehiclesState);
  const [vehiclesMeta, setVehiclesMeta] = useRecoilState(vehiclesMetaState);
  const [vehiclesView, setVehiclesView] = useRecoilState(vehiclesViewState);
  const [initial, setInitial] = useRecoilState(vehiclesInitialState);

  return {
    vehicles,
    setVehicles: (vehicles: Vehicle[]) => {
      setInitial(false);
      setVehicles(vehicles);
    },
    vehiclesMeta,
    setVehiclesMeta,
    vehiclesView,
    setVehiclesView,
    initial,
  };
}
